export default "__VITE_ASSET__DOdv3LRo__"